var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDataTab = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18.38,
    viewBox: "0 0 20 18.38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "article_person_16dp_3B3B3B_FILL0_wght300_GRAD0_opsz20",
    d: "M165.512-779.132v0Zm2.385-6.922h6.684q.052-.385.125-.763a3.036,3.036,0,0,1,.252-.75H167.9Zm0,4.537h5.792q.336-.244.659-.493a5.5,5.5,0,0,1,.679-.448q-.1-.137-.2-.276t-.191-.294H167.9Zm0-9.074h10.586V-792.1H167.9ZM165.87-777.62a1.806,1.806,0,0,1-1.328-.542A1.806,1.806,0,0,1,164-779.49v-14.64a1.806,1.806,0,0,1,.542-1.328A1.806,1.806,0,0,1,165.87-796h14.64a1.806,1.806,0,0,1,1.328.542,1.806,1.806,0,0,1,.542,1.328v4.456a5.061,5.061,0,0,0-.731-.359,4.774,4.774,0,0,0-.782-.231v-3.866a.342.342,0,0,0-.112-.246.342.342,0,0,0-.246-.112H165.87a.342.342,0,0,0-.246.112.341.341,0,0,0-.112.246v14.64a.341.341,0,0,0,.112.246.341.341,0,0,0,.246.112H172.5a.488.488,0,0,0-.012.147c0,.046.006.091.006.137v1.228Zm13.541-5.584a2.426,2.426,0,0,1-1.772-.729,2.394,2.394,0,0,1-.736-1.765,2.425,2.425,0,0,1,.73-1.771,2.393,2.393,0,0,1,1.765-.736,2.426,2.426,0,0,1,1.771.729,2.394,2.394,0,0,1,.736,1.765,2.427,2.427,0,0,1-.729,1.772A2.393,2.393,0,0,1,179.412-783.2Zm-4.6,5.584v-1.251a1.282,1.282,0,0,1,.072-.441,1.214,1.214,0,0,1,.215-.367,6.164,6.164,0,0,1,2-1.161,6.916,6.916,0,0,1,2.311-.387,6.849,6.849,0,0,1,2.289.387,6.431,6.431,0,0,1,2.02,1.161,1.209,1.209,0,0,1,.215.367,1.281,1.281,0,0,1,.072.441v1.251Z",
    transform: "translate(-164 796)",
    fill: "#0b004e"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDataTab, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dataTab.bda57017.svg";
export { ForwardRef as ReactComponent };